import { apiGuestClient } from './apiGuestClient';

export const QUAN_HE_CBNV_API_END_POINT = "quanhe-cbnv";

export const quanHeCbnvApi = {
    // Lấy tất cả tôn giáo
    selectAll: () => apiGuestClient.get(`${QUAN_HE_CBNV_API_END_POINT}`),
};
